import { isRejectedWithValue, Middleware } from '@reduxjs/toolkit';
import { ApiErrorHandler } from '../../shared/utils/apiErrorHandler';
import { logout } from '../slices/authSlice';
import { RootState } from '../store';
import { redirectToLogin } from '../../shared/utils/authRedirect';

export const errorMiddleware: Middleware = (store) => (next) => (action) => {
  // Handle RTK Query errors
  if (isRejectedWithValue(action)) {
    const { payload } = action;
    
    if (action.type === 'tutorApi/executeQuery/rejected') {
      // Check the meta information for endpoint details
      const meta = action.meta as any;
      if (meta?.arg?.endpointName === 'getCourseDetails') {
        console.log('Suppressing error for getCourseDetails endpoint', payload);
        return next(action);
      }
    }
    
    // Handle 401 errors by logging out
    if ((payload as any)?.status === 401) {
      const state = store.getState() as RootState;
      const hasToken = !!state.auth.token;
      const isLoginAction = action.type.includes('authApi') && action.type.includes('login');
      
      if (hasToken && !isLoginAction) {
        const user = state.auth.user;
        store.dispatch(logout());
        
        redirectToLogin(user?.userType as 'student' | 'tutor' | null);
      }
      
      return next(action);
    }
    
    // Handle other errors
    ApiErrorHandler.handle(payload, {
      showToast: true,
      silent: false,
    });
  }

  return next(action);
};